import { useEffect } from 'react';
import { useIntl } from 'react-intl';
import { COUNTRY_NOT_ALLOWED } from '../constants/errorKeys';
import { useAppDispatch } from "../store";
import { addToast } from "../store/toast";

export const useRegionValidation = () => {
    const intl = useIntl();
    const dispatch = useAppDispatch();
    const prohibitedCountry = sessionStorage.getItem(COUNTRY_NOT_ALLOWED);

    useEffect(() => {
        if (prohibitedCountry) {
            dispatch(addToast({
                type: 'error',
                message: intl.formatMessage({
                    id: 'auth.signUp.notAllowed',
                    defaultMessage: 'Access is blocked due to the region where you are located. Please contact customer support.',
                }),
                timeout: 10000,
            }));
            sessionStorage.removeItem(COUNTRY_NOT_ALLOWED);
        }
    }, [prohibitedCountry]);
}